// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"sidebarParticipants_sidebarWrapper__kn1km"};